import { inject } from '@angular/core';
import { LoadChildrenCallback, Routes } from '@angular/router';
import { ServerConfigService } from '../../data/server-config';
import { CustomElementHostChildPlaceholderComponent } from './components/custom-element-host-child-placeholder/custom-element-host-child-placeholder.component';
import { CustomElementHostPageComponent } from './pages/custom-element-host-page/custom-element-host-page.component';

/**
 * Builds child routes under `/customElements/...` from server config.
 * Must stay synchronous (same constraint as the legacy {@code ROUTES} factory).
 * Manifest JSON is still resolved at runtime in {@link CustomElementHostComponent}.
 */
function buildCustomElementRoutes(serverConfig: ServerConfigService): Routes {
  const elementRoutes: Routes = [];
  for (const entry of serverConfig.getCustomElementConfig() ?? []) {
    for (const item of entry.items?.filter((i) => i.route?.length > 0) ?? []) {
      elementRoutes.push({
        path: item.route,
        component: CustomElementHostPageComponent,
        data: {
          tagName: item.tagName,
          scriptPath: entry.pluginUrl,
          manifestSource: entry.manifestSource,
        },
        children: [
          {
            path: '**',
            component: CustomElementHostChildPlaceholderComponent,
          },
        ],
      });
    }
  }
  if (elementRoutes.length === 0) {
    return [{ path: '', pathMatch: 'full', redirectTo: '/' }];
  }
  return elementRoutes;
}

/**
 * Lazy child routes for {@code path: 'customElements'}.
 * Runs in the router's injection context so {@link inject} can resolve {@link ServerConfigService}.
 */
export const loadCustomElementChildren: LoadChildrenCallback = () =>
  buildCustomElementRoutes(inject(ServerConfigService));
